// extracted by mini-css-extract-plugin
export var infoRow = "_kf-2";
export var labelContainer = "_kf-0";
export var rightInfo = "_kf-1";